import * as React from 'react'
import { keys } from 'lodash'


export default class extends React.Component<any, any>{

    render(){
        const errors = this.props.errors;

        if(!errors || errors.length == 0){
            return null;
        }else{
            return (
                <div className="errors">
                    <div className="form-control-feedback"><i className="fa fa-exclamation-circle" aria-hidden="true"></i> { errors[0] }</div>
                </div>
            )
        }
    }

}


//{ errors.map(error => <div className="form-control-feedback"><i class="fa fa-exclamation-circle" aria-hidden="true"></i> {error}</div>)}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/components/errors.tsx